import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface SubItemTypeFilterProps {
  field: string;
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const subItemTypeOptions = [
  { label: 'Package', value: 'Fbm::Package' },
  { label: 'Group', value: 'Group' },
];

export const SubItemTypeFilter: React.FC<SubItemTypeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) =>
              subItemTypeOptions.find((option) => option.value === v)?.label ||
              ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  return (
    <Autocomplete
      multiple
      options={subItemTypeOptions.map((e) => e.value)}
      getOptionLabel={(option) =>
        subItemTypeOptions.find((e) => e.value === option)?.label || ''
      }
      value={selectedValues}
      onChange={(_, newValue) => setValue(newValue.join(','))}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={!selectedValues.length ? 'Any' : ''}
        />
      )}
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const name =
            subItemTypeOptions.find((e) => e.value === option)?.label ||
            'Unknown';
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip label={name} key={key} {...tagProps} />;
        })
      }
    />
  );
};
